import React, { useEffect, useState } from "react";
import { apiGet } from "../../api";
import { toast } from "react-toastify";

const StatCard = ({ label, value }) => (
  <div className="rounded-lg border border-border/70 bg-card p-5">
    <p className="text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1">
      {label}
    </p>
    <p className="font-mono text-xl text-foreground">{value ?? 0}</p>
  </div>
);

const AppCreditStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const res = await apiGet("/api/admin/dashboard/app-credit-stats");
      if (res.data.success) {
        setStats(res.data.data);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch app credit stats");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="p-4">
        <div className="text-center text-sm text-muted-foreground py-12">Loading stats...</div>
      </div>
    );
  }

  if (!stats) {
    return (
      <div className="p-4">
        <div className="text-center text-sm text-muted-foreground py-12">No stats available</div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="flex items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-1">
        <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
        Community
      </div>
      <h1 className="font-serif italic text-[45px] leading-[1.02] text-foreground">
        Credit <span className="text-gradient-ginox">Stats</span>
      </h1>
      <p className="text-sm text-muted-foreground mb-6">
        App-wide credit balance and spending breakdown.
      </p>

      <div className="mb-6">
        <p className="text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-3">
          Overall
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          <StatCard label="Total Available Balance" value={stats.totalAvailableBalance} />
          <StatCard label="Total Purchased" value={stats.totalPurchased} />
          <StatCard label="Total Spent" value={stats.totalSpent} />
          <StatCard label="Users with Balance" value={stats.usersWithBalance} />
        </div>
      </div>

      <div className="mb-6">
        <p className="text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-3">
          Spend by Service
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <StatCard label="Signal Channel" value={stats.spentOnSignalChannel} />
          <StatCard label="IPVPN" value={stats.spentOnIPVPN} />
          <StatCard label="Ginox AI" value={stats.spentOnGinoxAi} />
        </div>
      </div>
    </div>
  );
};

export default AppCreditStats;
